let requestController;

export function getRequestController() {
	if (!requestController || requestController.signal.aborted) {
		requestController = new AbortController();
	}

	return requestController;
}

export function resetRequestController() {
	requestController?.abort();
	requestController = new AbortController();
	return requestController;
}

export function abortRequestController() {
	requestController?.abort();
}
